
import Swal from "sweetalert2";
//import { Navigate } from "react-router-dom"; 
import ConfigService from './ConfigService';
import ApiService from "./ApiService";
import axios from "axios";
import authHeader from "./auth-header";
import { useNavigate } from "react-router-dom";


export function callAlert(title = '',
  msg = 'Communication error. Please try in some time',
  icon = 'error', // 'success' | 'error' | 'warning' | 'info' | 'question'
  timer = 5000 // Value 0 for no auto close alert
) {
  let SwalArr = {
    title: title,
    icon: icon,
    html: msg,
    showCloseButton: true,
    showCancelButton: false,
    focusConfirm: false,
    showConfirmButton: false,
    confirmButtonText: '<i className="fa fa-thumbs-up"></i> Great!',
    confirmButtonAriaLabel: '',
    cancelButtonText: '<i className="fa fa-thumbs-down"></i>',
  };

  if (timer) {
    SwalArr['timer'] = timer;
  }
  return Swal.fire(SwalArr);

}

export function AlertSuccess(
  title = "",
  text = "",
  callback = null,
  allowOutsideClick = true,
  timer = null, // Value 0 for no auto close alert
  confirmButtonText = "OK"
) {
  if (timer === null) {
    timer = 10000;
  }

  let SwalArr = {
    title: title,
    html: text,
    confirmButtonText: confirmButtonText,
    icon: "success",
    allowOutsideClick: allowOutsideClick,
    customClass: {
      actions: "my-actions",
      confirmButton: "order-2",
    },
  };
  if (timer) {
    SwalArr["timer"] = timer;
  }

  Swal.fire(SwalArr).then((result) => {
    if (callback) {
      callback(result);
    }
  });
}

/* 

export function callRedirect( url='' ) {  
    
    
    const navigate = Navigate()
  
        return navigate(url);
      
}
 
 */



export function getUserDetails() {



  let userDetails = '';
  if (localStorage.getItem('userDetails')) {
    userDetails = JSON.parse(localStorage.getItem('userDetails'))

  }

  return userDetails;
}


export function secondsToHms(d) {
  var hDisplay = "";
  var mDisplay = "00";
  var sDisplay = ":00";

  if (d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    hDisplay = h > 0 ? h + (h == 1 ? "h:" : "h:") : "";
    mDisplay = m > 0 ? m + (m == 1 ? "m:" : "m:") : "00";
    sDisplay = s > 0 ? s + (s == 1 ? "s" : "s") : "00";
  }

  return hDisplay + mDisplay + sDisplay;
}


// export function downloadPdfFile(url, name = 'syllabus') {

//   ///quiz/downloadAssignment 

//   // Create a link element
//   const link = document.createElement('a');
//   link.href = ConfigService.PUBLIC_URL + url;
//   link.download = name + '.pdf'; // Name of the downloaded file
//   link.click();
//   // const response = ApiService.publicGetRequest(url);
//   // console.log("Respose from dowload pdf", response.data)

// }


export function downloadPdfFile(url, name = 'syllabus', bodyData = null, sendJwt = false, method = "GET", callback = null) {
  let headers = {};

  if (sendJwt) {
    headers = authHeader();
  }

  axios({
    // url: ConfigService.PUBLIC_URL + url,
    url: ConfigService.FILE_URL + url,
    method: method,
    responseType: 'blob',
    headers: headers,
    // headers: authHeader(), // Conditionally include JWT token
    data: bodyData ? bodyData : null, // Conditionally send body data
  }).then((response) => {
    if (callback) {
      callback();
    }
    const link = document.createElement('a');
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const downloadUrl = window.URL.createObjectURL(blob);

    link.href = downloadUrl;
    link.download = name + '.pdf'; // Name of the downloaded file
    link.click();

    // Clean up the URL
    window.URL.revokeObjectURL(downloadUrl);

  }).catch((error) => {
    console.error('Error downloading the PDF:', error);
  });
}



export function isCheckedToken() {
  var isExpired = false;

  if (localStorage.getItem('userDetails')) {
    const token = JSON.parse(localStorage.getItem('userDetails'));
    //var decodedToken=jwt.decode(token.jwtToken, {complete: true});

    let decodedToken = JSON.parse(atob(token?.jwtToken.split('.')[1]));


    let oldDate = new Date(0).setUTCSeconds(decodedToken.exp);
    let millsecound = oldDate - new Date().getTime();
    let curent = millsecound / 1000;



    if (curent <= 5) {
      isExpired = true;
    }


  }



  return isExpired;
}


export function callAlertConfirm(
  title = '',
  text = '',
  callback = null,
  allowOutsideClick = true,
  timer = null, // Value 0 for no auto close alert
  confirmButtonText = 'Yes',
  denyButtonText = 'No'

) {
  if (timer === null) { timer = 50000; }

  let SwalArr = {
    title: title,
    html: text,
    showDenyButton: true,
    showCancelButton: false,
    confirmButtonText: confirmButtonText,
    denyButtonText: denyButtonText,
    icon: 'warning',
    allowOutsideClick: allowOutsideClick,
    customClass: {
      actions: 'my-actions',
      cancelButton: 'order-1 right-gap',
      confirmButton: 'order-2',
      denyButton: 'order-3',
    },
  }
  if (timer) {
    SwalArr['timer'] = timer;
  }

  Swal.fire(SwalArr).then((result) => {
    if (callback) {
      callback(result);
    }
  });
}



export function useApiClient() {
  console.log("using api client");

  localStorage.removeItem("userDetails");

  localStorage.removeItem("authToken");

  const event = new Event("logoutEvent");
  
  window.dispatchEvent(event);

  setTimeout(() => {
    window.location.reload(true);
  }, 50);




  // const logout=() => {
  //   localStorage.setItem("userDetails", "");  
  //   window.location.href ="/login";
  //   // navigate("/login");
  //   window.location.reload();
  // }

  // logout();


};








